<template>
  <div class="multi-input">
    <InputItem v-for="(v, index) in value" :key="index"
      :value="v"
      :items="items"
      :hasAdd="index == (value.length - 1) && value.length !== maxCount"
      :only="value.length <= minCount"
      @change="itemChange(index, $event)"
      @add="addItem(index)"
      @delete="deleteItem(index)" />
  </div>
</template>

<script>
import InputItem from './InputItem';

export default {
  name: 'MultiInput',
  components: {
    InputItem,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default () {
        return [];
      },
    },
    items: {
      type: Array,
      default () {
        return [];
      },
    },
    maxCount: {
      type: Number,
      default () {
        return 10000;
      },
    },
    minCount: {
      type: Number,
      default () {
        return 1;
      },
    },
  },
  data () {
    return {};
  },
  methods: {
    itemChange (index, value) {
      const values = this.value.slice(0);
      values.splice(index, 1, value);
      this.$emit('change', values);
    },
    addItem () {
      const values = this.value.slice(0);
      values.push({});
      this.$emit('change', values);
    },
    deleteItem (index) {
      const values = this.value.slice(0);
      values.splice(index, 1);
      this.$emit('change', values);
    },
  },
};
</script>

<style lang="less" scoped>

</style>
